
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Inairthreshold from "../../../store/entities/inairthreshold";
@Component
export default class EditInairthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  inairthreshold: Inairthreshold = new Inairthreshold();
  save() {
    (this.$refs.inairthresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "inairthreshold/update",
          data: this.inairthreshold,
        });
        (this.$refs.inairthresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
      else{
        (this.$refs.inairthresholdForm as any).resetFields();
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.inairthresholdForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.inairthreshold = Util.extend(true, {}, this.$store.state.inairthreshold.editInairthreshold);
    }
  }
  inairthresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    MAXPM10: [{required: true, message: "请填写PM10最大值", trigger: "blur" }],
    MAXPM25: [{required: true, message: "请填写PM2.5最大值", trigger: "blur" }],
  };
}
